
export default function TrainingSection() {
  const trainingPrograms = [
    {
      id: 'tailwheel',
      banner: 'Tailwheel Course',
      title: 'Tailwheel Endorsement',
      subtitle: 'Get back to basics and learn the skills every pilot should master!',
      description: 'Many pilots go their entire flying career having never flown a tailwheel airplane or flown from a grass runway. When you have earned your <strong>tailwheel endorsement</strong>, you will be better prepared to fly any aircraft you may encounter.',
      image: 'https://static.readdy.ai/image/d0668106bc926dd2e77bf53b05b8da4f/7f7cc88744486a9cc8719c74e889fdec.jpeg',
      features: ['Grass runway operations', 'Traditional flying skills', 'Enhanced aircraft control', 'Classic aviation experience']
    },
    {
      id: 'sport-pilot',
      banner: 'Sport Pilot License',
      title: 'Half the Cost – Twice the Fun!',
      subtitle: 'New rules expand privileges with no medical certificate required!',
      description: 'With a <strong>sport pilot license</strong>, you may fly all the classics and more and enjoy everything recreational aviation was meant to be! With our basic Sport Pilot training package, you may learn to fly as inexpensively as possible in our Cessna taildraggers.',
      image: 'https://readdy.ai/api/search-image?query=Light%20sport%20aircraft%20training%2C%20recreational%20flying%2C%20cessna%20sport%20pilot%20training%2C%20affordable%20flight%20instruction%2C%20fun%20aviation%20experience%2C%20modern%20flight%20training%2C%20accessible%20aviation%20education%2C%20beginner%20friendly%20aircraft&width=600&height=400&seq=sport-pilot&orientation=landscape',
      features: ['No medical certificate required', 'Cost-effective training', 'Recreational flying focus', 'Expanded privileges']
    },
    {
      id: 'private-pilot',
      banner: 'Private Pilot License',
      title: 'Freedom to Fly When You Want',
      subtitle: 'Bookings available now!',
      description: 'From those desiring a career in aviation to the pilots who want the freedom of travel without restrictions, Private Pilot Licensure is the first step for the majority of aviators across the USA. Our comprehensive program prepares you for unlimited flying privileges.',
      image: 'https://static.readdy.ai/image/d0668106bc926dd2e77bf53b05b8da4f/49d3631341dd7e2407da6526f3cdc75c.jpeg',
      features: ['Unlimited flying privileges', 'Career pathway preparation', 'Comprehensive training', 'Professional instruction']
    }
  ];

  return (
    <section id="training" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Barlow, sans-serif' }}>
            Why Choose Stiletto Airpark
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Professional aviation training in the heart of Central Texas, serving Bertram, Austin, Round Rock, Cedar Park, and surrounding communities with excellence and expertise.
          </p>
        </div>

        <div className="space-y-20">
          {trainingPrograms.map((program, index) => (
            <div key={program.id} className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-12`}>
              {/* Image */}
              <div className="lg:w-1/2">
                <div className="relative overflow-hidden rounded-2xl shadow-2xl">
                  <img 
                    src={program.image}
                    alt={`${program.title} training at Stiletto Airpark`}
                    className="w-full h-96 object-cover object-top transform hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-4 left-4 bg-teal-600 text-white px-4 py-2 rounded-full font-semibold">
                    {program.banner}
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="lg:w-1/2 space-y-6">
                <div>
                  <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3" style={{ fontFamily: 'Barlow, sans-serif' }}>
                    {program.title}
                  </h3>
                  <h4 className="text-xl md:text-2xl font-semibold text-teal-600 mb-4">
                    {program.subtitle}
                  </h4>
                  <p 
                    className="text-lg text-gray-700 leading-relaxed mb-6"
                    dangerouslySetInnerHTML={{ __html: program.description }}
                  />
                </div>

                {/* Features */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {program.features.map((feature, idx) => (
                    <div key={idx} className="flex items-center space-x-3">
                      <div className="w-6 h-6 flex items-center justify-center">
                        <i className="ri-check-line text-teal-600 text-xl"></i>
                      </div>
                      <span className="text-gray-700 font-medium">{feature}</span>
                    </div>
                  ))}
                </div>

                {/* CTA Buttons */}
                <div className="flex flex-col sm:flex-row gap-4 pt-4">
                  <a 
                    href="tel:706-936-8961"
                    className="bg-teal-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-teal-700 transition-colors text-center whitespace-nowrap cursor-pointer"
                  >
                    Book Training Now
                  </a>
                  <a 
                    href={program.id === 'tailwheel' ? '/training/tailwheel-endorsement' : 
                          program.id === 'sport-pilot' ? '/training/sport-pilot' : 
                          program.id === 'private-pilot' ? '/training/private-pilot' : 
                          "tel:512-635-0847"}
                    className="border-2 border-teal-600 text-teal-600 px-6 py-3 rounded-lg font-semibold hover:bg-teal-600 hover:text-white transition-colors text-center whitespace-nowrap cursor-pointer"
                  >
                    Learn More
                  </a>
                </div>

              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
